"use strict";

require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.object.keys.js");
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _usePrefixCls = require("../_utils/hooks/usePrefixCls");
var _controlled = require("../Form/controlled");
var _noop = require("../_utils/noop");
var _Dropdown = _interopRequireDefault(require("../Dropdown"));
var _List = _interopRequireDefault(require("../List"));
var _injectValue = require("../_utils/injectValue");
var _NativeSelect = require("./NativeSelect");
var _excluded = ["className", "value", "onChange", "groups", "options", "placeholder", "button", "type", "disabled", "style", "onOpen", "onClose", "boxStyle", "boxClassName", "boxSizeSync", "size", "mSize", "width"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var SimulateSelect = function SimulateSelect(props) {
  var _useDefaultValue = (0, _controlled.useDefaultValue)(props, ''),
    className = _useDefaultValue.className,
    value = _useDefaultValue.value,
    onChange = _useDefaultValue.onChange,
    _useDefaultValue$grou = _useDefaultValue.groups,
    groups = _useDefaultValue$grou === void 0 ? {} : _useDefaultValue$grou,
    _useDefaultValue$opti = _useDefaultValue.options,
    options = _useDefaultValue$opti === void 0 ? [] : _useDefaultValue$opti,
    _useDefaultValue$plac = _useDefaultValue.placeholder,
    placeholder = _useDefaultValue$plac === void 0 ? '请选择' : _useDefaultValue$plac,
    button = _useDefaultValue.button,
    type = _useDefaultValue.type,
    disabled = _useDefaultValue.disabled,
    style = _useDefaultValue.style,
    _useDefaultValue$onOp = _useDefaultValue.onOpen,
    _onOpen = _useDefaultValue$onOp === void 0 ? _noop.noop : _useDefaultValue$onOp,
    _useDefaultValue$onCl = _useDefaultValue.onClose,
    onClose = _useDefaultValue$onCl === void 0 ? _noop.noop : _useDefaultValue$onCl,
    _useDefaultValue$boxS = _useDefaultValue.boxStyle,
    boxStyle = _useDefaultValue$boxS === void 0 ? {} : _useDefaultValue$boxS,
    boxClassName = _useDefaultValue.boxClassName,
    boxSizeSync = _useDefaultValue.boxSizeSync,
    size = _useDefaultValue.size,
    mSize = _useDefaultValue.mSize,
    width = _useDefaultValue.width,
    extraProps = (0, _objectWithoutProperties2.default)(_useDefaultValue, _excluded);
  var prefixCls = (0, _usePrefixCls.usePrefixCls)('list');
  var selected = value != null ? options.find(function (x) {
    return x.value === value;
  }) : undefined;

  // 选项消失不影响已选中值显示
  var _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    buttonOption = _useState2[0],
    setButtonOption = _useState2[1];

  // 类名
  var classes = (0, _classnames2.default)(prefixCls, (0, _defineProperty2.default)({}, "".concat(prefixCls, "-placeholder"), !buttonOption), className);

  // options 中有选中项时改变 buttonOption
  (0, _react.useEffect)(function () {
    if (selected) {
      setButtonOption(selected);
    }
  }, [options]);

  // value 变化时改变 buttonOption 及搜索框状态
  (0, _react.useEffect)(function () {
    if (selected) {
      setButtonOption(selected);
    } else {
      setButtonOption(null);
    }
  }, [value]);
  var buttonPlaceholder = placeholder;
  if (!type || type === 'button' || type === 'text') {
    buttonPlaceholder = /*#__PURE__*/_react.default.createElement("div", null, placeholder);
  }

  // 按钮文字
  var buttonText =
  // eslint-disable-next-line no-nested-ternary
  buttonOption ? typeof buttonOption.text === 'undefined' ? buttonOption.value : buttonOption.text : buttonPlaceholder;

  // input value
  var inputValue =
  // eslint-disable-next-line no-nested-ternary
  buttonOption ? buttonOption.value : '';
  var ref = (0, _react.useRef)(null);
  var renderGroup = function renderGroup(close) {
    var groupDatas = (0, _NativeSelect.getGroupDatas)(options);
    return /*#__PURE__*/_react.default.createElement(_List.default, {
      type: "option"
    }, Object.keys(groupDatas).map(function (key) {
      return /*#__PURE__*/_react.default.createElement(_List.default.Group, {
        label: groups[key],
        key: key
      }, groupDatas[key].map(function (item) {
        return /*#__PURE__*/_react.default.createElement(_List.default.Item, {
          key: item.value
          // selected={item.selected}
          ,
          disabled: item.disabled
          // tooltip={item.tooltip}
          ,
          onClick: function onClick(event) {
            onChange(item.value, {
              event: event
            });
            close();
          }
        }, item.text);
      }));
    }));
  };
  var renderOptions = function renderOptions(close) {
    return /*#__PURE__*/_react.default.createElement(_List.default, {
      type: "option"
    }, options.map(function (item) {
      return /*#__PURE__*/_react.default.createElement(_List.default.Item, {
        key: item.value,
        selected: value === item.value,
        current: item.current,
        disabled: item.disabled
        // tooltip={item.tooltip}
        ,
        onClick: function onClick(event) {
          onChange(item.value, {
            event: event
          });
          close();
        }
      }, item.text);
    }));
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("input", {
    type: "hidden",
    defaultValue: inputValue
  }), /*#__PURE__*/_react.default.createElement(_Dropdown.default, (0, _extends2.default)({
    updateOnChildrenChange: true,
    className: classes,
    ref: ref,
    boxStyle: boxStyle,
    boxClassName: boxClassName,
    boxSizeSync: boxSizeSync,
    style: style,
    type: type,
    size: size,
    mSize: mSize,
    width: width,
    onOpen: function onOpen() {
      _onOpen();
    },
    disabled: disabled,
    button: typeof button !== 'undefined' ? (0, _injectValue.injectValue)(button)(buttonOption) : buttonText
  }, extraProps), options.find(function (opt) {
    return !!opt.groupKey;
  }) ? renderGroup : renderOptions));
};

// 组件的默认值
SimulateSelect.defaultProps = {
  className: ''
};
var _default = exports.default = SimulateSelect;